module.exports = __webpack_public_path__ + "static/media/mainMenu.44925f23.pdf";